import { Chip, ChipProps } from "@mui/material";
import { CoinIcon } from "@/components/common/icons";
import { InvoiceStatus } from "@/types";
import { getInvoiceLabelAndColor } from "@/utils/invoiceChip";

export default function InvoiceStatusChip({
  status,
  small = false,
  withPrefix = false,
  withIcon = true,
}: {
  status: InvoiceStatus;
  small?: boolean;
  withPrefix?: boolean;
  withIcon?: boolean;
}) {
  const smallProps: ChipProps = {
    size: "small",
  };

  const { label, baseColor } = getInvoiceLabelAndColor(status, withPrefix);

  const textColor = baseColor[100];
  const icon = <CoinIcon size={small ? 16 : 20} color={textColor} />;

  return (
    <Chip
      icon={withIcon ? icon : undefined}
      label={label}
      {...(small && smallProps)}
      sx={{ backgroundColor: baseColor[40], color: textColor }}
    />
  );
}
